import { render, staticRenderFns } from "./ClientUnitCard.vue?vue&type=template&id=130a9cc4&scoped=true"
import script from "./ClientUnitCard.vue?vue&type=script&lang=js"
export * from "./ClientUnitCard.vue?vue&type=script&lang=js"
import style0 from "./ClientUnitCard.vue?vue&type=style&index=0&id=130a9cc4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a9cc4",
  null
  
)

export default component.exports